import { combineReducers } from "redux";
import { i18nReducer } from 'react-redux-i18n';
import donationReducer from "../pages/donate/reducer";
import pageReducer from "../pages/shared/reducer";

export const rootReducer = combineReducers({
    page: pageReducer,
    donation: donationReducer,
    i18n: i18nReducer,
});
